export default "__VITE_ASSET__DtawFIBl__"